import { Calendar } from 'fullcalendar';

export default (el) => {
    let calendarEl = document.querySelector('#calendar');
    if(calendarEl == undefined)
        return
    
    let idSirtaqui = unescape(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + escape("id").replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
    let url = window.location.host;

    if(url === "wwwdev.seppa-dev.ovh"){
        url = url + "/ares";
    }

    url = "https://" + url + "/sirtaqui/get_calendar.php?id=" + idSirtaqui;
    const data = fetch(url).then((r) => r.json());

    data.then((data) => {
        let events = [],
            now = new Date().getFullYear(),
            next = now +1,
            link  = document.createElement('link');
        
        link.rel  = 'stylesheet';
        link.type = 'text/css';
        link.href = 'https://cdnjs.cloudflare.com/ajax/libs/fullcalendar/3.9.0/fullcalendar.min.css';
        document.querySelector('head').appendChild(link)

        data.forEach(year => {
            year.calendar.forEach(month => {
                events.push({
                    start: month.start,
                    end: month.end,
                    backgroundColor: month.color
                })
            });
        });

        console.log(events);

        let calendar = new Calendar(calendarEl, {
            defaultView: 'month',
            locale: 'fr',
            header: {
                left: 'prev',
                center: 'title',
                right: 'next'
            },
            weekends: true,
            firstDay: 1,
            buttonIcons: {
                prev: 'left-single-arrow',
                next: 'right-single-arrow',
            },
            showNonCurrentDates: false,
            displayEventTime: false,
            validRange: {
                start: now.toString() + '-01-01',
                end: next.toString() + '-12-31'
            },            
            views: {
                month: {
                    displayEventEnd: true,
                },
                defaultView: {
                    displayEventEnd: true,
                }
            },
            height: 'auto',
            events: events
        })
    
        calendar.render();
    })
}